module.exports = __webpack_public_path__ + "static/media/photos-videos-home-icon.56fcaaf1.svg";